import React from 'react';

type IconProps = {
  className?: string;
  width?: number | string;
  height?: number | string;
  'aria-label'?: string;
};

const card = (rx = 4) => ({ width: '100%', height: '100%', rx }) as const;

export const VisaIcon: React.FC<IconProps> = ({
  width = 38,
  height = 24,
  className,
  'aria-label': ariaLabel = 'Visa',
}) => (
  <svg
    role="img"
    aria-label={ariaLabel}
    width={width}
    height={height}
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect {...card()} fill="#1A1F71" />
    <text
      x="24"
      y="21"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="11"
      fontWeight="900"
      fontStyle="italic"
      fill="#FFFFFF"
      textAnchor="middle"
      letterSpacing="0.5"
    >
      VISA
    </text>
  </svg>
);

export const MastercardIcon: React.FC<IconProps> = ({
  width = 38,
  height = 24,
  className,
  'aria-label': ariaLabel = 'Mastercard',
}) => (
  <svg
    role="img"
    aria-label={ariaLabel}
    width={width}
    height={height}
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect {...card()} fill="#FFFFFF" stroke="#E5E7EB" />
    <circle cx="20" cy="16" r="7.5" fill="#EB001B" />
    <circle cx="28" cy="16" r="7.5" fill="#F79E1B" />
    <path
      d="M24 10.5a7.5 7.5 0 0 1 0 11 7.5 7.5 0 0 1 0-11z"
      fill="#FF5F00"
    />
  </svg>
);

export const AmexIcon: React.FC<IconProps> = ({
  width = 38,
  height = 24,
  className,
  'aria-label': ariaLabel = 'American Express',
}) => (
  <svg
    role="img"
    aria-label={ariaLabel}
    width={width}
    height={height}
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect {...card()} fill="#2E77BB" />
    <text
      x="24"
      y="14"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="6"
      fontWeight="700"
      fill="#FFFFFF"
      textAnchor="middle"
      letterSpacing="0.3"
    >
      AMERICAN
    </text>
    <text
      x="24"
      y="22"
      fontFamily="Arial, Helvetica, sans-serif"
      fontSize="6"
      fontWeight="700"
      fill="#FFFFFF"
      textAnchor="middle"
      letterSpacing="0.3"
    >
      EXPRESS
    </text>
  </svg>
);

export const ApplePayIcon: React.FC<IconProps> = ({
  width = 38,
  height = 24,
  className,
  'aria-label': ariaLabel = 'Apple Pay',
}) => (
  <svg
    role="img"
    aria-label={ariaLabel}
    width={width}
    height={height}
    viewBox="0 0 48 32"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <rect {...card()} fill="#000000" />
    <path
      d="M14.02 12.76c-.38.45-.99.8-1.6.75-.08-.6.22-1.25.57-1.64.39-.46 1.05-.78 1.59-.81.06.62-.19 1.25-.56 1.7zm.55.87c-.88-.05-1.63.5-2.05.5-.43 0-1.07-.47-1.77-.46-.91.01-1.76.53-2.22 1.35-.96 1.65-.25 4.1.67 5.44.45.66.99 1.39 1.7 1.36.68-.03.94-.44 1.76-.44.82 0 1.06.44 1.77.43.74-.01 1.2-.66 1.65-1.32.51-.75.72-1.48.73-1.52-.02-.01-1.41-.54-1.42-2.13-.01-1.33 1.09-1.97 1.14-2-.63-.93-1.6-1.03-1.96-1.05zM19.9 11.7v9.5h1.47v-3.25h2.04c1.86 0 3.17-1.28 3.17-3.13 0-1.85-1.28-3.12-3.12-3.12H19.9zm1.47 1.24h1.7c1.28 0 2.01.69 2.01 1.89 0 1.2-.73 1.89-2.02 1.89h-1.69V12.94zM28.93 21.28c.92 0 1.78-.47 2.17-1.21h.03v1.13h1.36V16.5c0-1.37-1.09-2.25-2.78-2.25-1.56 0-2.72.89-2.76 2.12h1.33c.11-.58.65-.97 1.39-.97.89 0 1.39.42 1.39 1.19v.52l-1.82.11c-1.7.1-2.62.79-2.62 2 0 1.22.95 2.06 2.31 2.06zm.4-1.12c-.78 0-1.27-.37-1.27-.95 0-.59.47-.95 1.38-1l1.63-.1v.53c0 .88-.75 1.52-1.74 1.52zM34.24 23.83c1.43 0 2.1-.55 2.69-2.21l2.58-7.22h-1.49l-1.73 5.58h-.03l-1.73-5.58h-1.53l2.48 6.86-.13.42c-.22.71-.58.98-1.23.98-.12 0-.34-.01-.43-.03v1.13c.09.02.45.05.55.05z"
      fill="#FFFFFF"
    />
  </svg>
);
